
export default {
  name: "TabMenu",
  props: {
    margin: {
      default: '',
      type: String,
    },
    tabIsOpen: {
      default: '',
      type: String,
    }
  },
  render() {
    const slot = this.$slots.default
    //  return slot.text.replace(/,/g, "")
    return slot
  },

}
